import React from 'react'
import styles from './loader.scss'

export default class Loader extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			display: 'none',
		}
	}
	componentDidMount() {
		this.timer = setTimeout(() => this.setState({display: 'block'}), 250)
	}
	componentWillUnmount() {
		clearTimeout(this.timer)
	}
	render() {
		const {display} = this.state
		return (
			<div style={{display}} className={styles.loaderWrapper}>
				<div className={styles.spinner}>
					<div className={styles.dot1}/>
					<div className={styles.dot2}/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/loader.jsx